import { gql } from '@apollo/client';

export default gql`
  mutation DeleteProductFeatureProductMutation($productFeatureProductId: Int!) {
    deleteProductFeatureProductById(input: { id: $productFeatureProductId }) {
      productFeatureByProductFeatureId {
        id
      }
    }
  }
`;
